function Moon() {
  const fill = '#C7D2FE'

  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g fill={fill}>
        <path
          d="M10.744 2.49199L9.79795 2.17699L9.48195 1.22999C9.37995 0.923988 8.87295 0.923988 8.77095 1.22999L8.45495 2.17699L7.50895 2.49199C7.35595 2.54299 7.25195 2.68599 7.25195 2.84799C7.25195 3.00999 7.35595 3.15299 7.50895 3.20399L8.45495 3.51899L8.77095 4.46599C8.82195 4.61899 8.96495 4.72199 9.12595 4.72199C9.28695 4.72199 9.43095 4.61799 9.48095 4.46599L9.79695 3.51899L10.743 3.20399C10.896 3.15299 11 3.00999 11 2.84799C11 2.68599 10.896 2.54299 10.743 2.49199H10.744Z"
          fill={fill}
        />
        <path
          d="M8.5 7.74999C6.153 7.74999 4.25 5.84699 4.25 3.49999C4.25 2.48199 4.623 1.56099 5.219 0.828995C2.693 1.20799 0.75 3.36799 0.75 5.99999C0.75 8.89899 3.101 11.25 6 11.25C8.632 11.25 10.792 9.30699 11.171 6.78099C10.439 7.37799 9.518 7.74999 8.5 7.74999Z"
          stroke={fill}
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default Moon
